import { Box, styled } from '@mui/material'

const HiddenMobile = styled(Box)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    display: 'none'
  }
}))

export default HiddenMobile
